/**
 * !!! EDIT WITH CAUTION: THESE ARE PRODUCTION VALUES !!!
 *
 * This is the production config and the fallback for any environment without
 * its own config. Every environment inherits these values and overrides only
 * what it needs to, so a change here reaches production and every lower
 * environment that does not override that toggle.
 *
 * Turn a release toggle on here only when the feature is ready for production.
 */
import { AppEnv } from '../../shared/appEnv';
import {
    FeatureToggleName,
    IFeatureToggle,
    IFeatureToggles,
    IFlatFeatureToggles,
} from '../featureToggles.types';

// Typed as IFlatFeatureToggles so adding a toggle to the registry without a
// production value here is a compile error.
const defaultValues: IFlatFeatureToggles = {
    [FeatureToggleName.ExamplePilotFeature]: false,
    [FeatureToggleName.Config_ExampleConfigToggle]: false,
    // The toggle check page is never built in production.
    [FeatureToggleName.Config_FeatureFlagCheckPage]: false,
    // Off until a flag needs post-build control in production.
    [FeatureToggleName.Config_RuntimeToggleSource]: false,
    [FeatureToggleName.MockExampleScenario]: false,
};

/** Production toggle values keyed by name. Clone it; never mutate it. */
export const defaultFeatureTogglesMap: ReadonlyMap<
    FeatureToggleName,
    IFeatureToggle
> = new Map(
    (Object.keys(defaultValues) as FeatureToggleName[]).map((name) => [
        name,
        { name, isEnabled: defaultValues[name] },
    ]),
);

export const featureTogglesDefault: IFeatureToggles = {
    environment: AppEnv.Prod,
    toggles: Array.from(defaultFeatureTogglesMap.values()),
};

/**
 * Build a lower environment's config: start from the production defaults and
 * apply that environment's overrides, matched by toggle name.
 */
export const extendDefaultFeatureToggles = (
    environment: AppEnv,
    overrides: IFeatureToggle[],
): IFeatureToggles => {
    const togglesMap = new Map(defaultFeatureTogglesMap);
    overrides.forEach((toggle) => togglesMap.set(toggle.name, toggle));

    return {
        environment,
        toggles: Array.from(togglesMap.values()),
    };
};
